import { useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import { PAYMENT_REPORTS } from "../../graphql/queries/Providers";

/**
 * Loads the payment report for the logged-in provider.
 *
 * Claims from before Oct 2023 are queried by date of service; anything newer is
 * queried by paid date.
 *
 * @param {string} payment_type "eft" | "check" | "debit"
 * @param {{fromdate: string, todate: string}} props the owning component's props
 */
export default function usePaymentReport(payment_type, props) {
    const provider_id = parseInt(window.localStorage.getItem("providerID"));

    var from_date_of_service = null;
    var to_date_of_service = null;
    var from_paid_date = "";
    var to_paid_date = "";

    var fromYear;
    var fromMonth;

    if (props.fromdate) {
        from_date_of_service = props.fromdate;
        from_paid_date = props.fromdate;
        fromYear = parseInt(props.fromdate.substring(0, 4));
        fromMonth = parseInt(props.fromdate.substring(5, 7));
    }

    if (props.todate) {
        to_date_of_service = props.todate;
        to_paid_date = props.todate;
    }

    var sendPaidDate = true;

    if (fromYear <= 2023) {
        if (fromYear < 2023) {
            sendPaidDate = false;
        } else if (fromMonth < 10 && fromYear === 2023) {
            sendPaidDate = false;
        }
    } else {
        sendPaidDate = true;
    }

    const [loadReports, { data }] = useLazyQuery(PAYMENT_REPORTS, {
        variables: sendPaidDate
            ? {
                  provider_id,
                  payment_type,
                  from_paid_date,
                  to_paid_date,
                  from_requested_date: null,
                  to_requested_date: null,
              }
            : { provider_id, payment_type, from_date_of_service, to_date_of_service },
    });

    useEffect(() => {
        loadReports();
    }, [props]);

    return data;
}


